import { GraphErrors } from './errors';

export type ThreadErrorType =
  | 'DEFAULT'
  | 'BLACKLISTED_WORDS'
  | 'RATE_LIMIT_EXCEEDED'
  | 'UNAUTHORIZED_REPLY';

export class ThreadError extends GraphErrors {
  constructor(public readonly key: ThreadErrorType = 'DEFAULT') {
    super(key);
    this.name = 'ThreadError';
  }
}
